import store from '@/store';
import { notify } from '@/shared/utils/browser-notify';
import { selectContactByLatestInteraction } from '@/shared/utils/contact-helpers';
import i18n from '@/i18n';
import { getContactByPhone } from '@/services/contact-service';
import ContactService from '@/services/contact-service';
import { webRTCAcceptCall } from '@/weon/web-rtc/WeonWebRTC.js';
export default class VoiceAgentCalledEvent {
  constructor(body) {
    if (
      store.state.attendance.Attendance.agentAckCall &&
      store.state.attendance.Attendance.useWebRTC === 'Y'
    ) {
      console.log(
        '%c [event]',
        'color: #F44336;',
        JSON.stringify(body, null, 4),
      );

      const agentId = store.state.attendance.Attendance.agentId;
      const uniqueId = body.callUniqueid;
      const phone = body.phone;
      const queue = body.queueId;
      const transferFrom = body.transferFrom;
      const transferFromName = body.transferFromName;
      const transferFromType = body.transferFromType;
      const transfer = body.transferedCall;
      const transferType = body.transferedType;
      const contactId = body.contactId;

      getContactByPhone(phone, agentId).then(async (contacts) => {
        if (queue == '') {
          if (body.transferedCall) {
            webRTCAcceptCall();
          } else {
            if (store.state.dialogs.dialogTransferCallReceived) {
              webRTCAcceptCall();
            } else {
              const notification = await this.setBrowserNotificationText(
                contacts.data,
                phone,
              );
              notify(notification, true);
              const callInformation = await this.setDialogContent(
                contacts.data,
                phone,
                uniqueId,
                agentId,
                transferFrom,
                transferFromName,
                transferFromType,
                transfer,
                transferType,
              );
              store.dispatch(
                'jobs/ackCallRequestSetInformation',
                callInformation,
              );
              store.dispatch('jobs/ackCallRequestShowDialog', true);
              const notificationApp = await this.setAppNotificationText(phone);
              store.dispatch('addNotification', notificationApp);
            }
          }
        } else {
          if (queue.substr(0, 4) == '1111') {
            webRTCAcceptCall();
          } else {

            let contactFound = null;
            if (contactId) {
              contactFound = await this.findContactById(contactId);
            }

            let attendanceGroupFound = this.findAttendanceGroupByQueue(queue);

            if (
              transfer &&
              attendanceGroupFound.ackCallAssistedTransferBehavior ===
                'automatic'
            ) {
              webRTCAcceptCall();
            } else {
              if (attendanceGroupFound != undefined) {
                if (attendanceGroupFound.ackCallBehavior == 'ring') {
                  const notification = await this.setBrowserNotificationText(
                    contacts.data,
                    phone,
                  );
                  notify(notification, true);

                  const callInformation = await this.setDialogContent(
                    contactId ? contactFound : contacts.data,
                    phone,
                    uniqueId,
                    agentId,
                    transferFrom,
                    transferFromName,
                    transferFromType,
                    transfer,
                    transferType,
                  );
                  store.dispatch(
                    'jobs/ackCallRequestSetInformation',
                    callInformation,
                  );
                  store.dispatch('jobs/ackCallRequestShowDialog', true);

                  const notificationApp =
                    await this.setAppNotificationText(phone);
                  store.dispatch('addNotification', notificationApp);
                } else {
                  webRTCAcceptCall();
                }
              }
            }
          }
        }
      });
    }
  }

  async setBrowserNotificationText(contacts, phoneNumber) {
    if (contacts.length == 0) {
      return {
        title: i18n.t('ackCallRequest.browserNotification.newCallTitle'),
        body: i18n.t('ackCallRequest.browserNotification.contactNotFound', {
          phoneNumber,
        }),
      };
    }

    if (contacts.length == 1) {
      return {
        title: i18n.t('ackCallRequest.browserNotification.newCallTitle'),
        body: i18n.t('ackCallRequest.browserNotification.contactFound', {
          phoneNumber,
          contactFullname: contacts[0].fullname,
        }),
      };
    }

    if (contacts.length > 1) {
      let contactSelected = await selectContactByLatestInteraction(
        contacts,
        phoneNumber,
        'voice',
      );
      return {
        title: i18n.t('ackCallRequest.browserNotification.newCallTitle'),
        body: i18n.t('ackCallRequest.browserNotification.contactFound', {
          phoneNumber,
          contactFullname:
            contactSelected != null
              ? contactSelected.fullname
              : contacts[0].fullname,
        }),
      };
    }
  }

  setAppNotificationText(phoneNumber) {
    return {
      eventType: 'callReceived',
      message: i18n.t('ackCallRequest.appNotification.callReceived', {
        phoneNumber,
      }),
      title: i18n.t('types_alert.callReceived'),
    };
  }

  async setDialogContent(
    contacts,
    phoneNumber,
    uniqueId,
    agentId,
    transferFrom,
    transferFromName,
    transferFromType,
    transfer,
    transferType,
  ) {
    if (contacts.length == 0) {
      return {
        info: {
          name: i18n.t('ackCallRequest.appNotification.contactNotFound'),
          phoneNumber,
          uniqueId,
          agentId,
          type: 'notFound',
          transferFrom,
          transferFromName,
          transferFromType,
          transfer,
          transferType,
          employerName: null,
        },
      };
    }

    if (contacts.length == 1) {
      return {
        info: {
          name: contacts[0].fullname,
          id: contacts[0].id,
          phoneNumber,
          uniqueId,
          agentId,
          type: 'contactFound',
          transferFrom,
          transferFromName,
          transferFromType,
          transfer,
          transferType,
          employerName: contacts[0].employer_name,
        },
      };
    }

    if (contacts.length > 1) {
      let contactSelected = await selectContactByLatestInteraction(
        contacts,
        phoneNumber,
        'voice',
      );
      return {
        info: {
          name:
            contactSelected != null
              ? contactSelected.fullname
              : contacts[0].fullname,
          phoneNumber,
          uniqueId,
          agentId,
          type: 'contactFound',
          transferFrom,
          transferFromName,
          transferFromType,
          transfer,
          transferType,
          employerName:
            contactSelected != null
              ? contactSelected.employe_name
              : contacts[0].employe_name,
        },
      };
    }
  }

  findAttendanceGroupByQueue(queue) {
    return store.state.attendanceGroups.groupList.find((attendanceGroup) => {
      if (attendanceGroup.channel == 'voice') {
        let queueNumber = attendanceGroup.queue_voice_context.split('queue_');
        if (queue == queueNumber[1]) {
          return attendanceGroup;
        }
      }
      return null;
    });
  }

  async findContactById(contactId) {
    let contact = await ContactService.getById(contactId);

    if (contact.data.length > 0) {
      return contact.data;
    }
    return null;
  }
}
